/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useEffect,useState } from 'react';
import { useDispatch } from 'react-redux';
import Header from '@/components/Header';
import ResizeWrapper from '@/components/ResizeWrapper';
import Menu from './Menu';
import { useIsMobile } from '@/utils/utils';
import Apis from '@/app/index';
import MainArea from './MainArea';
import { ABORT_VISIBILITY_CHANGE, useLeave } from '@/lib/useCommon';
import { RTCConfig, SceneConfig, updateRTCConfig, updateScene, updateSceneConfig } from '@/store/slices/room';
import styles from './index.module.less';

const ACCESS_PASSWORD = 'medicup@2026';
export default function () {

  const leaveRoom = useLeave();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

 const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const getScenes = async () => {
    const { scenes }: {
      scenes: {
        rtc: RTCConfig;
        scene: SceneConfig;
      }[];
    } = await Apis.Basic.getScenes();
    dispatch(updateScene(scenes[0].scene.id));
    dispatch(updateSceneConfig(
      scenes.reduce<Record<string, SceneConfig>>((prev, cur) => {
        prev[cur.scene.id] = cur.scene;
        return prev;
      }, {})
    ));
    dispatch(updateRTCConfig(
      scenes.reduce<Record<string, RTCConfig>>((prev, cur) => {
        prev[cur.scene.id] = cur.rtc;
        return prev;
      }, {})
    ));
  }

  useEffect(() => {
    getScenes();
    const isOriginalDemo = window.location.host.startsWith('localhost');
    const handler = () => {
      if (
        document.visibilityState === 'hidden' &&
        !sessionStorage.getItem(ABORT_VISIBILITY_CHANGE)
      ) {
        leaveRoom();
      }
    };
    !isOriginalDemo && document.addEventListener('visibilitychange', handler);
    return () => {
      !isOriginalDemo && document.removeEventListener('visibilitychange', handler);
    };
  }, []);

    const handlePasswordSubmit = () => {
    if (password === ACCESS_PASSWORD) {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('密码错误，请重试');
      setPassword('');
    }
  };
  
    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
          handlePasswordSubmit();
        }
      };
if (!isAuthenticated) {
    return (
        <div className={styles.passwordContainer}>
          <div className={styles.passwordBox}>
            <div className={styles.passwordTitle}>访问验证</div>
            <div className={styles.passwordDesc}>请输入访问密码</div>
            <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="请输入密码"
                className={styles.passwordInput}
            />
            {error && <div className={styles.passwordError}>{error}</div>}
            <button onClick={handlePasswordSubmit} className={styles.passwordButton}>
              确认访问
            </button>
          </div>
        </div>
    );
  }

  return (
    <ResizeWrapper className={styles.container}>
      <Header />
      <div
        className={styles.main}
        style={{
          padding: isMobile ? '' : '24px',
        }}
      >
        <div className={`${styles.mainArea} ${isMobile ? styles.isMobile : ''}`}>
          <MainArea />
        </div>
        {isMobile ? null : (
          <div className={styles.operationArea}>
            <Menu />
          </div>
        )}
      </div>
    </ResizeWrapper>
  );
}
